export default __webpack_public_path__ + "static/media/xtreme-project-4.949403b3.webp";